import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import api from '../../api/axiosConfig';
import logo from '../../assets/logo.jpeg'; 
import TwoFactorModal from '../../components/TwoFactorModal/TwoFactorModal';
import './Login.css';

const Login = () => {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.registeredEmail || '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [pendingToken, setPendingToken] = useState(null);
  const [loginLoading, setLoginLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    setError('');
    try {
      const rememberToken = localStorage.getItem('rememberToken');
      const response = await api.post('/login', { email, password, rememberToken });

      if (response.data.requiresTwoFactor) {
        setPendingToken(response.data.pendingToken);
        return;
      }

      localStorage.setItem('token', response.data.token);
      navigate('/dashboard');
    } catch (err) {
      setError('Error al iniciar sesion. Revisa tus credenciales.');
    } finally {
      setLoginLoading(false);
    }
  };

  const handleTwoFactorSuccess = (data) => {
    localStorage.setItem('token', data.token);
    if (data.rememberToken) {
      localStorage.setItem('rememberToken', data.rememberToken);
    }
    setPendingToken(null);
    navigate('/dashboard');
  };

  const handleTwoFactorError = () => {
    setPendingToken(null);
    setError('Error en la verificación de dos pasos. Reintentá el login.');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        
        <div className="logo-container">
          <img src={logo} alt="Estudio Metzger" className="logo-image" />
        </div>

        <h2 className="login-title">Iniciar Sesion</h2>
        {error && <div className="error-message"><i className="bi bi-exclamation-circle" style={{ marginRight: 8 }}></i>{error}</div>}
        
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">
              <i className="bi bi-envelope" style={{ marginRight: 6 }}></i>Email
            </label>
            <input 
              type="email" 
              className="form-input"
              value={email} 
              onChange={e => setEmail(e.target.value)} 
              placeholder="correo@ejemplo.com"
              required 
              disabled={loginLoading}
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">
              <i className="bi bi-lock" style={{ marginRight: 6 }}></i>Contrasena
            </label>
            <input 
              type="password" 
              className="form-input"
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              placeholder="••••••••"
              required 
              disabled={loginLoading}
            />
          </div>
          
          <button type="submit" className="submit-btn" disabled={loginLoading}>
            {loginLoading ? 'Ingresando...' : <><i className="bi bi-box-arrow-in-right" style={{ marginRight: 8 }}></i>Ingresar</>}
          </button>
        </form>
        
        <div className="register-link-container">
          <Link to="/forgot-password" className="register-link" style={{ display: 'block', marginBottom: '12px' }}>Olvidaste tu contraseña?</Link>
          No tienes cuenta? <Link to="/register" className="register-link">Registrate</Link>
        </div>
      </div>

      {pendingToken && (
        <TwoFactorModal
          pendingToken={pendingToken}
          onSuccess={handleTwoFactorSuccess}
          onError={handleTwoFactorError}
        />
      )}
    </div>
  );
};

export default Login;
